export var initialState = {
    filesUploadCount: 0,
    uploadedFileCount: 0,
};
